<template>
  <b-row v-if="countDownTime <=1300">
    <b-col>
      <b-icon @click="setUpClock" id="clock" icon="clock" class="mr-2 font-weight-bolder"></b-icon>
      <b-badge class="font-weight-bolder" :variant="colorOfClock" @click="setUpClock">{{ clockView }}</b-badge>
    </b-col>
    <BaseBModal
        id="timer-modal-id"
        :isSelected="false"
        :headerBgVariant="this.popupData.headerBgVariant"
        modalSize="md"
        :withoutSubmit="true"
        :hideFooter="false"
        :withSideIcon="true"
        :modalReturnVariant="popupData.modalReturnVariant"
        @handle-modal-return="popupAction"
        buttonReturnCaption="Αποδοχή"
        :titleHtml="popupData.title"
    >
      <template #modal-form>
        {{ popupData.content }}
      </template>
    </BaseBModal>
  </b-row>
</template>

<script>
import moment from "moment";
import BaseBModal from "@/components/base/BaseBModal.vue";
import AuthServices from "@/service/AuthServices";
import {toggleBusy} from "@/util/ComponentUtils";

export default {
  name: 'BaseTimer',
  components: {
    BaseBModal
  },
  data() {
    return {
      countDownTime: 1800,
      popupData: {
        action: null,
        title: null,
        content: null,
        modalReturnVariant: 'danger'
      }
    }
  },
  watch: {
    countDownTime() {
      if (this.countDownTime == 0) {
        this.popupData.action = 'endOfTime'
        this.popupData.title = "O χρόνος έληξε"
        this.popupData.headerBgVariant = "danger"
        this.popupData.modalReturnVariant = "danger"
        this.popupData.content = "Ο χρόνος έληξε και θα αποσυνδεθείτε αυτόματα."
        this.$bvModal.show("timer-modal-id")
      } else if (this.countDownTime == 540) {
        this.popupData.action = 'minimumTime'
        this.popupData.title = "Ανανέωση χρόνου"
        this.popupData.headerBgVariant = "info"
        this.popupData.modalReturnVariant = "info"
        this.popupData.content = "Έχει απομείνει λιγότερο από 30% του χρόνου σύνδεσης,παρακαλούμε αποθηκεύστε ή πατήστε στην ένδειξη του ρολογιού για ανανέωση χρόνου ώστε να μη χαθούν τα δεδομένα σας"
        this.$bvModal.show("timer-modal-id")
      }
    },

  },
  computed: {
    colorOfClock() {
      if (this.countDownTime > 1200) {
        return 'success'
      } else if (this.countDownTime > 540 && this.countDownTime <= 1200) {
        return 'warning'
      } else if (this.countDownTime <= 540) {
        return 'danger'
      }
    },
    clockView() {
      return moment.utc(this.countDownTime * 1000).format("mm:ss");
    }
  },
  methods: {
    countDownTimer() {
      if (this.countDownTime > 0) {
        setTimeout(() => {
          this.countDownTime -= 1
          this.countDownTimer()
        }, 1000)
      }
    },
    async setUpClock() {
      let response = await AuthServices.isAuthenticated();
      if ([200, 202].includes(response.status)) {
        this.countDownTime = 1800;
      } else {
        await this.$store.dispatch("logout")
        await this.$store.dispatch("auth/resetState")
        await this.$store.dispatch("caption/resetState")
        await this.$store.dispatch("catalog/resetState")
        await toggleBusy(false)
        await this.$router.push("/");
      }
      this.countDownTime = 1800;
    },
    async popupAction() {
      if (this.popupData.action == 'endOfTime') {
        await AuthServices.signOut();
        await this.$store.dispatch("logout")
        await this.$store.dispatch("auth/resetState")
        await this.$store.dispatch("caption/resetState")
        await this.$store.dispatch("catalog/resetState")
        await this.$router.push("/");
      } else if (this.popupData.action == 'minimumTime') {
        await this.setUpClock();
      }
      this.$bvModal.hide("timer-modal-id")
    }
  },
  created() {
    this.countDownTimer()
  }
}
</script>

